import { gtcDebounce } from "./gtc-utils.js";
const productCardImageSelector = ".product-card__image--primary";

/************************* *Content block  *************************/
class ContentBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.dom = {
      container: this.querySelector(".gtc__content-block__media-container"),
    };

    if (this.hasAttribute("match-product-image-height")) {
      this.init();
    }
  }

  init() {
    const productImage = this.parentElement.querySelector(
      productCardImageSelector
    );
    if (!productImage) {
      return;
    }

    const handleResize = gtcDebounce(() => {
      this.dom.container.style.minHeight =
        productImage.getBoundingClientRect().height + "px";
    }, 10);
    window.addEventListener("resize", handleResize);
    this.dom.container.style.minHeight =
      productImage.getBoundingClientRect().height + "px";
  }
}

if (!customElements.get("gtc-content-block")) {
  customElements.define("gtc-content-block", ContentBlock);
}

class VideoAutoplay extends HTMLElement {
  constructor() {
    super();

    this.videoElement = null;
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.videoElement = this.querySelector('video');
    if (this.videoElement) {
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
      this.intersectionObserver.observe(this.videoElement);
    }

  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.videoElement);
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    const isVisible = entries[0].isIntersecting;
    if (isVisible) {
      this.playVideo();
      console.log('play');
    } else {
      this.pauseVideo();
      console.log('pause');
    }
  }

  playVideo() {
    if (this.videoElement) {
      this.videoElement.play();
    }
  }

  pauseVideo() {
    if (this.videoElement) {
      this.videoElement.pause();
    }
  }
}

if (!window.customElements.get('video-autoplay')) {
  customElements.define('video-autoplay', VideoAutoplay);
}